let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("PMoQX")).then(() => parcelRequire('h95YY'));